import { render, staticRenderFns } from "./CvPage.vue?vue&type=template&id=49e1bfd2&scoped=true"
import script from "./CvPage.vue?vue&type=script&lang=js"
export * from "./CvPage.vue?vue&type=script&lang=js"
import style0 from "./CvPage.vue?vue&type=style&index=0&id=49e1bfd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e1bfd2",
  null
  
)

export default component.exports